import { render, staticRenderFns } from "./Shantuantuan.vue?vue&type=template&id=653891de&"
import script from "./Shantuantuan.vue?vue&type=script&lang=js&"
export * from "./Shantuantuan.vue?vue&type=script&lang=js&"
import style0 from "./Shantuantuan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports